import * as Sentry from "@sentry/react";
import { isQuotaExceededError, safeSessionStorage } from "../safeLocalStorage";

export type SessionData = {
  hasHoveredHotelPin: boolean;
  hasSeenDateAutoPopup: boolean;
};

export function useSessionStorage() {
  function clear() {
    safeSessionStorage.clear();
  }

  function setItem(key: keyof SessionData, value: string) {
    try {
      safeSessionStorage.setItem(key, value);
    } catch (error) {
      // We already check if Storage is supported or full on-load.
      // If storage is full here, it's possible this item has caused it.
      const isStorageFull =
        isQuotaExceededError(error) && safeSessionStorage.length > 0;
      Sentry.captureException(error, (scope) => {
        scope.setTransactionName(
          "Failed to setItem in useSessionStorage hook.",
        );
        scope.setExtra("isStorageFull", isStorageFull);
        scope.setExtra("value", value);
        return scope;
      });

      // We want to allow the app to set other keys if this one fails.
      // we're also trying to prevent access to stale data under this key.
      safeSessionStorage.removeItem(key);
    }
  }
  function removeItem(key: keyof SessionData) {
    safeSessionStorage.removeItem(key);
  }
  function getItem(key: keyof SessionData) {
    return safeSessionStorage.getItem(key);
  }

  return {
    setItem,
    getItem,
    removeItem,
    clear,
  };
}
